import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../redux/AppTypes";

export function useManagers(): string[] {
  const managers = useSelector((state: AppState) => state.managers.items);
  return Object.keys(managers);
}
